import s from './LocationPreviewCard.module.css';
import type { ReactNode } from 'react';
import { Flex } from '@repo/ui/Flex';
import { Box } from '@repo/ui/Box';

export const LocationPreviewCard = ({
  title,
  icon,
  attribute,
  description,
  hours,
  url,
}: {
  title: string | ReactNode | null;
  icon: string | null;
  attribute?: string | null;
  description?: ReactNode;
  hours?: string;
  url?: ReactNode;
}) => (
  <Flex alignItems="center" className={s.wrapper} gap="g-16">
    {icon && (
      <Box className={s.icon} padding="p-8">
        <img src={icon} alt="" />
      </Box>
    )}
    <Flex className={s.descriptionWrapper} direction="column" gap="g-4">
      <div className={s.name}>{title}</div>
      <div className={s.description}>{description ?? url}</div>
      {hours && <div className={s.description}>{hours}</div>}
    </Flex>
    <div className={s.attribute}>{attribute}</div>
  </Flex>
);
